/**
 * Submits a form on the site. Every enquiry is stored and emailed to the team.
 * Resolves with { success, message } — never throws, so a form can show a
 * friendly message instead of blowing up the page.
 */
import { apiUrl } from '../api';

export async function submitEnquiry(payload) {
  try {
    const res = await fetch(apiUrl('/api/enquiries'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    const data = await res.json();
    return {
      success: Boolean(data.success),
      message: data.message || (data.success ? 'Thank you!' : 'Something went wrong. Please try again.'),
    };
  } catch {
    return { success: false, message: "We couldn't reach the server. Please check your connection and try again." };
  }
}
